import Vue from "vue";
import App from "./App.vue";
import Vuetify from "vuetify";
import VeeValidate from "vee-validate";
import VueRouter from "vue-router";
import router from "./router";
import Notifications from "vue-notification";
import videojshotkeys from "videojs-hotkeys";
import "video.js/dist/video-js.css";
import "vuetify/dist/vuetify.min.css";
import store from "@/store/";
import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import "@/assets/css/styles.min.css"; // Import Icons8 Font Library CSS file
import DatetimePicker from "vuetify-datetime-picker";
import axios from "axios";
import moment from "moment";
Vue.prototype.$moment = moment;

Vue.prototype.$axios = axios;

Vue.use(DatetimePicker);

//vue good table
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
Vue.use(VueGoodTablePlugin);

//firebase
const firebase = require("./firebase/config.js");
Vue.prototype.$firebase = firebase;

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(videojshotkeys);
Vue.use(VeeValidate, {
  events: ""
});

Vue.use(Vuetify, {
  iconfont: "icons8",
  theme: {}
/*    primary: store.state.portal.active.primary,
    secondary: store.state.portal.active.secondary,
    accent: store.state.portal.active.accent,
    error: store.state.portal.active.error,
    page: store.state.portal.active.page
    // info: store.state.portal.active.info
  }*/
  //theme to go here
});

/* Import Lodash Libraries */
import _ from "lodash-es";
import groupBy from "lodash-es/groupBy";
import find from "lodash-es/find";
import filter from "lodash-es/filter";
import sortBy from "lodash-es/sortBy";
// import orderBy from "lodash-es/orderBy";
import uniqBy from "lodash-es/uniqBy";
import uniq from "lodash-es/uniq";
import map from "lodash-es/map";
import has from "lodash-es/has";
import pick from "lodash-es/pick";
import omit from "lodash-es/omit";
import unionBy from "lodash-es/unionBy";
import reduce from "lodash-es/reduce";

// import includes from "lodash-es/includes";

Vue.prototype.$_ = _;
Vue.prototype.$unionBy = unionBy;
Vue.prototype.$groupBy = groupBy;
Vue.prototype.$omit = omit;
Vue.prototype.$has = has;
Vue.prototype.$uniqBy = uniqBy;
Vue.prototype.$uniq = uniq;
Vue.prototype.$filter = filter;
Vue.prototype.$pick = pick;
Vue.prototype.$find = find;
Vue.prototype.$sortBy = sortBy;
Vue.prototype.$reduce = reduce;

//Vue.prototype.$orderBy = orderBy;
Vue.prototype.$map = map;

Vue.use(Notifications);

//print options
import VueHtmlToPaper from "vue-html-to-paper";

import './registerServiceWorker'

const options = {
  name: "_blank",
  specs: ["fullscreen=no", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"
  ]
};

Vue.use(VueHtmlToPaper, options);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

